module.exports = __webpack_public_path__ + "assets/webgl/Assets_2_base_color.b8aa2c15.jpg";